ApiAjax = require 'app/scripts/network/api-ajax'
LimitMixin = require 'app/scripts/lib/limit-mixin'
TrelloModel = require 'app/scripts/models/internal/trello-model'
Util = require 'app/scripts/lib/util'
_ = require 'underscore'

class Checklist extends TrelloModel
  typeName: 'Checklist'
  urlRoot: ->
    '/1/checklists'

  @lazy
    checkItemList: ->
      # Dependency required at call site to avoid import cycles, do not lift to top of module
      CheckItemList = require 'app/scripts/models/collections/check-item-list'
      new CheckItemList().syncSubModels(@, 'checkItems')

  sync: (method, model, options) ->
    if method == 'create' && !(@get('idBoard')? && @get('idCard')?)
      @waitForAttrs @, ['idBoard', 'idCard'], (attrs) =>
        @set(attrs)
        super(method, model, options)

      @waitForId @getBoard(), (id) => @set('idBoard', id)
      @waitForId @getCard(), (id) => @set('idCard', id)
    else
      super

  getCard: ->
    @modelCache.get('Card', @get('idCard')) ? @collection.sourceModel

  getBoard: ->
    @getCard()?.getBoard()

  getCheckItemCount: ->
    @checkItemList.length

  getCompletedCount: (card) ->
    count = 0

    @checkItemList.each (checkItem) ->
      if checkItem.get('state')?
        count++ if (checkItem.get('state') == 'complete')

    count

  getCheckItem: (idCheckItem) -> @checkItemList.get(idCheckItem)

  editable: -> @getBoard().editable()

  calcPos: (index, checkItem) ->
    Util.calcPos(index, @checkItemList, checkItem)

  _debouncedRequestNewState: _.debounce((newState) ->
    ApiAjax
      url: "/1/checklist/#{@id}/checkItems/all"
      type: 'put'
      retry: false
      data:
        state: newState
      success: =>
        @_originalCheckListState = null
      error: =>
        # Reset the state if it goes wrong.
        @checkItemList.each (checkItem) =>
          checkItem.set 'state', @_originalCheckListState[checkItem.id]
        @_originalCheckListState = null
  , 500)

  toggleCheckItemsState: (newState) ->
    # As the request is debounced if we got the 'original' state every function
    # call, by the time the request we actually made the original is lost, this
    # would mean the server state wouldn't reflect the local one if the request
    # fails, this is not a good user experience, so let's cache it on the first
    # request and clear it when debounced function has done it's thing
    @_originalCheckListState ?= {}
    @checkItemList.each (checkItem) =>
      @_originalCheckListState[checkItem.id] ?= checkItem.get 'state'
      checkItem.set('state', newState)

    @_debouncedRequestNewState newState

_.extend Checklist.prototype, LimitMixin

module.exports = Checklist
